import { motion } from "framer-motion";
import { useLang } from "../i18n";
import { Wrench, ShieldCheck, MapPin, Route } from "lucide-react";

const ICONS = [Wrench, ShieldCheck, MapPin, Route];

export default function Experience() {
  const { t } = useLang();
  return (
    <section id="experience" className="max-w-7xl mx-auto px-6 py-24">
      <div className="grid grid-cols-1 lg:grid-cols-6 gap-6">
        <div className="lg:col-span-4 card-brutal overflow-hidden relative min-h-[340px]">
          <img src="https://images.unsplash.com/photo-1783832435880-4737e0770aea?q=80&w=1600&auto=format&fit=crop"
            alt="Moto en carretera costera" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
          <div className="relative p-10 flex flex-col justify-end h-full min-h-[340px]">
            <p className="uppercase text-xs tracking-[0.25em] text-brand font-extrabold mb-3">{t.exp.eyebrow}</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-white max-w-lg">{t.exp.title}</h2>
          </div>
        </div>
        <div className="lg:col-span-2 bg-brand border-2 border-topacio-ink rounded-xl shadow-[4px_4px_0_0_#111] p-8 flex flex-col justify-between">
          <span className="font-hand text-4xl text-topacio-red">100% Canarias</span>
          <p className="text-topacio-ink font-semibold leading-relaxed">{t.exp.sub}</p>
        </div>
        {t.exp.items.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div key={i} data-testid={`exp-item-${i}`}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`${i % 2 === 0 ? "lg:col-span-2" : "lg:col-span-4"} card-brutal p-8 hover:-translate-y-1 hover:shadow-[8px_8px_0_0_#111] transition-[transform,box-shadow]`}>
              <div className="w-12 h-12 bg-brand border-2 border-topacio-ink rounded-lg flex items-center justify-center shadow-[3px_3px_0_0_#111]">
                <Icon className="w-6 h-6 text-topacio-ink" strokeWidth={2.2} />
              </div>
              <h3 className="font-display text-lg font-bold text-topacio-ink mt-5">{item.t}</h3>
              <p className="text-sm text-topacio-faded mt-2 leading-relaxed">{item.d}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
